// extracted by mini-css-extract-plugin
export var button = "_f2-4";
export var hasDarkBackground = "_f2-7";
export var hasLightBackground = "_f2-6";
export var iconWrapper = "_f2-0";
export var large = "_f2-2";
export var medium = "_f2-1";
export var small = "_f2-5";
export var xsmall = "_f2-3";